/**
 * 去掉 OSS 访问 URL 上的预签名查询串与 hash，得到稳定路径，供请求后端预签名接口或作为预览缓存 key。
 */
export function normalizeOssUrlForPresign(rawUrl) {
  if (!rawUrl || typeof rawUrl !== 'string') return rawUrl
  const trimmed = rawUrl.trim()
  if (!trimmed) return trimmed
  try {
    const u = new URL(trimmed)
    return `${u.origin}${u.pathname}`
  } catch {
    const noHash = trimmed.split('#')[0]
    const q = noHash.indexOf('?')
    return q >= 0 ? noHash.slice(0, q) : noHash
  }
}
